/* eslint-disable no-restricted-syntax */
import DOMPurify from "dompurify";
import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
  selectors: {
      root: '.language-form',
      customselect: '.language-form__custom-select',
      selectItems: '.language-form__select-items',
      selectItem: '.language-form__select-item',
      selectSelected: '.language-form__select-selected',
      languageCheckbox: '.language-form__language-item',
      languageCheckboxIcon: '.language-form__language-item-icon',
      country: '.language-form__country',
      checkbox: '.language-form__language-item-input',
      languages: '.language-form__language'
  },
  classNames: {
      customselect: 'language-form__custom-select',
      selectSelected: 'language-form__select-selected',
      selectNotSelected: 'language-form__select-not-selected',
      selectSelectedActive: 'language-form__select-selected--active',
      selectItems: 'language-form__select-items',
      selectItemsHide: 'language-form__select-hide',
      selectItem: 'language-form__select-item',
      sameAsSelected: 'language-form__same-as-selected',
      countrySearchbar: 'language-form__searchbar',
      countrySearchbarInput: 'language-form__searchbar-input',
      languageCheckbox : 'language-form__language-item',
      languageCheckboxActive : 'language-form__language-item--active',
      languageCheckboxShow : 'language-form__language-item--show',
      languageCheckboxIconActive: 'language-form__language-item-icon--active',
      languageText: 'language-form__language-item-text',
      customSelectActive: 'language-form__custom-select--active',
      countryActive: 'language-form__country--active',
      languagesHidden: 'language-form__language--hidden',
      overlayButton: 'navigation__top-action--country',
  },
  dataSets: {
    isoCode: 'data-iso-code',
    languages: 'data-languages',
    forwardTarget: 'data-forward-target',
    checkboxLanguageCode: 'data-language-code',
    countriesJson: 'data-countries-json',
    flagsPath: 'data-flags-path',
    countryFlagsElements: 'data-country-flag'
  }
 
};

class LanguageForm {

  constructor($rootElement) {
      this._$rootElement = $rootElement;
      this._elements = null;
      this._index = 0;
      this.data = [];
      this.fetchedCountryData = [];
      this.setLanguages = [];
      this.allAvailableLanguages = [];

      this.countrySelection = {
        isoCode: '',
        languageSelected: '',
      }

  }

  init() {
      this._elements = this._getDomElements();
      this._doAsync();
  }

  async _doAsync() {
    let data = null;
    try {
      data = await this._fetchCountriesJSON();
    } catch (error) {
      const fetchMock  = await this._fetchMockData();
      data = fetchMock;
      if (fetchMock === null || fetchMock === undefined) {
        return;
      }
    } finally {
      this.fetchedCountryData = data;

      // console.log('this.fetchedCountryData', this.fetchedCountryData);

      if(!this.fetchedCountryData) {
        return;
      }

      // this._checkCookie();
      
      const sortCountriesBySortTitle = this._sortSelectOptionCountries(this.fetchedCountryData);
      this._getAllLanguagesAvailableFromJson();
      this._generateSelect();
      this._extractIsoAndLanguageFromUrl();
      this._fillSelectOptionsCountries(sortCountriesBySortTitle);
      this._addCurrentCountry();
      this._addEventListeners();

      $('*[data-language-code]').removeClass('language-form__language-item--active');

      const lang = window.location.pathname.split('/')[2];
      $(`*[data-language-code="${lang}"]`).addClass('language-form__language-item--active');
    }
  }

  // _checkCookie() {
  //   const cookieString = document.cookie;
  //   const cookies = cookieString.split('; ');
  //   let hasCookie = false;

  //   cookies.forEach(cookie => {
  //     const key = cookie.split('=');
  //     if(key === 'language_cookie') {
  //       hasCookie = true;
  //     }
  //   });

  //   if(hasCookie) return;


  //   const urlLanguage = this._extractIsoAndLanguageFromUrl();

  //   console.log(urlLanguage);
    
  //   const userLang = navigator.language || navigator.userLanguage;   
  //   document.cookie += '; ' + userLang;
  //   const localeParts = userLang.split('-');
  //   const currentURL = window.location.toString();

  //   if(!currentURL.includes(urlLanguage.languageSelected) || !currentURL.includes(urlLanguage.isoCode)) return;

  //   location.href = currentURL.replace(`/${urlLanguage.isoCode}/${urlLanguage.languageSelected}`, `/${localeParts[0].toLowerCase()}/${localeParts[1]}`);

  // }

  _getDomElements() {
      return {
        $customSelect: this._$rootElement.find(config.selectors.customselect),
        $selectItems: this._$rootElement.find(config.selectors.selectItems),
        $selectItem: this._$rootElement.find(config.selectors.selectItem),
        $selectSelected: this._$rootElement.find(config.selectors.selectSelected),
        $languageCheckbox: this._$rootElement.find(config.selectors.languageCheckbox),
        $languageCheckboxIcon: this._$rootElement.find(config.selectors.languageCheckboxIcon),
        $country: this._$rootElement.find(config.selectors.country),
        $checkbox: this._$rootElement.find(config.selectors.checkbox),
        $languages: this._$rootElement.find(config.selectors.languages)
      };
  }

  async _fetchCountriesJSON() {
    const getUrlFromDataAttribute = document.querySelector(`.${config.classNames.overlayButton}`).getAttribute(config.dataSets.countriesJson);
    const url = getUrlFromDataAttribute;

    const fetchedCountriesData = await $.get(url);

    const response = fetchedCountriesData;
    this.fetchedCountryData = response;

      return fetchedCountriesData;
  }

  async _fetchMockData() {
    const url = '/assets/mock/countries.json';

    const fetchedCountriesData = fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.fetchedCountryData = data;
        return data;
      })
      .catch((error) => {
        console.error(`Error in promise chain: ${error}`)
        this.fetchedCountryData = {};
      });

      this.fetchedCountryData = fetchedCountriesData;
      return fetchedCountriesData;
  }

  _addEventListeners() {
    $(document.getElementsByClassName('overlay-footer__inner')[0].children)[0].addEventListener('click', () => {
      this._$rootElement.closest('.overlay__header').removeClass('overlay__header--sticky');
      this._$rootElement.closest('.overlay').removeClass('overlay--visible');
      $('html').removeClass('body--no-scroll');
      this._changeUrl();
    });
    
    $('.language-form__searchbar-input').on('input', (e) => {
      const searchResults = this._getTitleBySearchTerm(e.currentTarget.value);
      this._fillSelectOptionsCountries(searchResults);
    });

    this._$rootElement.closest('.overlay').find('.overlay__close-btn').on('click', () => {
      this._$rootElement.closest('.overlay__header').removeClass('overlay__header--sticky');
      this._$rootElement.closest('.overlay').removeClass('overlay--visible');
      $('html').removeClass('body--no-scroll');
      
      setTimeout(() => {
        $('.language-form__searchbar-input').val('');
        const searchResults = this._getTitleBySearchTerm('');
        this._fillSelectOptionsCountries(searchResults);
        this._closeAllSelects();
      }, 2000);
    });
  }

  _changeUrl() {
    const urlLanguage = this._extractIsoAndLanguageFromUrl();
    const currentURL = window.location.toString().replace(`/${urlLanguage.isoCode}/${urlLanguage.languageSelected}`, `/${this.countrySelection.isoCode.toLowerCase()}/${this.countrySelection.languageSelected}`);;
    location.href = DOMPurify.sanitize(currentURL);
  }

  _extractIsoAndLanguageFromUrl() {
    const isProdStage = this._proofProdStage();
    if (!isProdStage) {
      return {
        isoCode: 'gb',
        languageSelected: 'en'
      }
    }
    const currentUrl = window.location.href;
    const hostLength = window.location.host.length + 3;
    const protocolLength = window.location.protocol.length;

    // slice just lang info 
    const slicedUrl = currentUrl.slice(protocolLength + hostLength, protocolLength + hostLength + 5);


    const splitSlicedUrl = slicedUrl.split('/');
  
    return {
      isoCode: splitSlicedUrl[0],
      languageSelected: splitSlicedUrl[1]
    }
  }

  _getAllLanguagesAvailableFromJson() {
    if (this.fetchedCountryData[0].languageList !== undefined) {
      this.allAvailableLanguages = this.fetchedCountryData[0].languageList;
    }
  }

  _renderLanguageCheckboxes(languages) {
    const languageCodesArray = languages.split(';');
    const resultsOfFilter = [];
    const checkboxesToBeReplaced = $(`.${config.classNames.languageCheckbox}`);
    
    // Removing existing checkboxes
    checkboxesToBeReplaced.each((index, checkbox) => checkbox.remove());

    languageCodesArray.forEach((languageCode, index) => {
      const filteredLanguage = this.allAvailableLanguages.filter(language => language.languageCode === languageCode)
      resultsOfFilter.push(filteredLanguage[0]);
    })

    resultsOfFilter.map((item, index) => {
      const checkboxElement = `
        <label class="${config.classNames.languageCheckbox}" data-language-code="${item.languageCode}" for="${item.languageName}">
          <span class="language-form__language-item-icon icon-check"></span>
          <span class="language-form__language-item-text">${item.languageName} </span>
          <input class="language-form__language-item-input" aria-label="${item.languageName}" type="checkbox" name="${item.languageName}" value="${item.languegeName}" id="${item.languageCode}" >
        </label>
      `;

      this._elements.$languages.append(DOMPurify.sanitize(checkboxElement));
    })
  
    this._setCheckboxActiveAccordingToBrowserLanguage(languageCodesArray);
    this._onCheckboxClicked();
  }

  _getDetailsByIsoCode(isoCode) {
    return Object.values(this.fetchedCountryData).find(country => country.isoCode === isoCode);
  }

  _getTitleBySearchTerm(searchTerm) {
    const results = [];
    const sortData = this._sortSelectOptionCountries(this.fetchedCountryData);
    
    sortData.forEach((country, index) => {
      if (country[0] !== undefined) {
        if (country[0].toUpperCase().includes(searchTerm.toUpperCase()) && !results.includes()) {
          results.push(country);
        } 
        else {
          let languageVariationOfCountryAvailable = false;
          country[1].countriesInDifferentLanguages.forEach((title, index) => {
            // Creating element to escape HTML entities like &Uuml; as Ü
            const decodeElement = document.createElement('p');
            decodeElement.innerHTML = title;
            if (decodeElement.innerHTML.toUpperCase().includes(searchTerm.toUpperCase())) {
              languageVariationOfCountryAvailable = true;
            }
          })
          if (languageVariationOfCountryAvailable) {
            results.push(country);
          }
        }
      }
    })
    return results;
  }
 
  async _generateSelect() {
    
      var  customSelect, i, j, customSelectLength, selectLength, selElmnt, selectSelected, selectItems, selectItem;
      /*look for any elements with the class "custom-select":*/
      customSelect = document.getElementsByClassName(config.classNames.customselect);
      customSelectLength = customSelect.length;
     
      for (i = 0; i < customSelectLength; i++) {
          selElmnt = customSelect[i].getElementsByTagName('select')[0];
          selectLength = selElmnt.length;

          /*for each element, create a new span  that will act as the selected item:*/
          selectSelected = document.createElement('span');
          selectSelected.setAttribute('class', config.classNames.selectSelected);
          selectSelected.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          customSelect[i].appendChild(selectSelected);
          
          //create new div with class searchbar
          let searchbar = document.createElement('input');
          let searchcontainer = document.createElement('div');
          searchcontainer.setAttribute('class', config.classNames.countrySearchbar)
          searchbar.setAttribute('class', 'language-form__searchbar-input')
          searchbar.setAttribute('placeholder', 'Select Country')
          searchbar.setAttribute('name', 'language-searchbar-input')
          searchbar.setAttribute('aria-label', 'Country Search')
          let searchicon = document.createElement('i');
          searchicon.setAttribute('class', 'language-form__searchbar-input-icon icon-TickCircleSearch1');
          searchcontainer.appendChild(searchicon);
          searchcontainer.appendChild(searchbar);

          /*for each element, create a new DIV that will contain the option list:*/
          selectItems = document.createElement('DIV');
          selectItems.setAttribute('class', config.classNames.selectItems);
          selectItems.classList.add(config.classNames.selectItemsHide)

          //append searchbar div at selectitems div
          selectItems.appendChild(searchcontainer)
          
         
          for (j = 1; j < selectLength; j++) {
          
              /*for each option in the original select element,
              create a new DIV that will act as an option item:*/
              selectItem = document.createElement('span');
              selectItem.setAttribute('class', config.classNames.selectItem);
              selectItem.innerHTML = selElmnt.options[j].innerHTML;

              const $this = this;

              selectItem.addEventListener('click', function(e) {
                  /*when an item is clicked, update the original select box,
                  and the selected item:*/
                  var sameAsSelectedItem, i, k, defaultSelect, selectedItem, defaultSelectLength, sameAsSelectedItemLength;
                  defaultSelect = this.parentNode.parentNode.getElementsByTagName('select')[0];
                  defaultSelectLength = defaultSelect.length;
                  selectedItem = this.parentNode.previousSibling;
                 
                  for (i = 0; i < defaultSelectLength; i++) {
                      if (defaultSelect.options[i].innerHTML == this.innerHTML) {
                        defaultSelect.selectedIndex = i;

                        //get value of select
                          const $customSelect = $this._$rootElement.find(config.classNames.customselect);
                          const hiddenSelect = $customSelect.find("select");
                          hiddenSelect.val(this.innerHTML);

                          selectedItem.innerHTML = this.innerHTML;
                          
                          sameAsSelectedItem = this.parentNode.getElementsByClassName(config.classNames.sameAsSelected);
                          sameAsSelectedItemLength = sameAsSelectedItem.length;

                          for (k = 0; k < sameAsSelectedItemLength; k++) {
                            $(sameAsSelectedItem[k]).removeClass(config.classNames.sameAsSelected);
                          }
                        
                          $(this).addClass(config.classNames.sameAsSelected) ;
                          break;
                      }
                  }

                  selectedItem.click();
              });
              selectItems.appendChild(selectItem);
          }

          customSelect[i].appendChild(selectItems);
          const $this = this;
          selectSelected.addEventListener('click', function(e) {
              /*when the select box is clicked, close any other select boxes,
              and open/close the current select box:*/
              e.stopPropagation();
              const nextsibling = this.nextSibling;
              var customSelect = this.parentNode;
              var formCountry = this.parentNode.parentNode
              customSelect.classList.toggle(config.classNames.customSelectActive)
              formCountry.classList.toggle(config.classNames.countryActive)
              nextsibling.classList.toggle(config.classNames.selectItemsHide);

              if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                $('.language-form__language').addClass(config.classNames.languagesHidden)
              }

              $(`.${config.classNames.countrySearchbarInput}`).val('');
              const searchInput = document.querySelector(`.${config.classNames.countrySearchbarInput}`);
              setTimeout(() => searchInput.focus(), 500);
            });
          }
         
    
     /*if the user clicks anywhere outside the select box,
      then close all select boxes:*/
      window.addEventListener("click",  this._closeAllSelects );

  }

  _fillSelectOptionsCountries(sortCountriesBySortTitle) {
    // const data = await this._fetchCountriesJSON();
    // Elements generated locally
    const htmlAutoGeneratedElements = document.querySelectorAll(`.${config.classNames.selectItem}`);
    const htmlItemsWrapper = document.querySelector(`.${config.classNames.selectItems}`);

    if (htmlAutoGeneratedElements != undefined || htmlAutoGeneratedElements != null) {
      htmlAutoGeneratedElements.forEach((item, index) => item.remove());
    }

    sortCountriesBySortTitle.forEach((country, index) => {
      // show-in-selector 1 means it's supposed to be displayed
      if (country[1].showInSelector != 1) {
        return;
      }
     
      const dataLableIso = config.dataSets.isoCode;
      const dataLableLang = config.dataSets.languages;
  
      // class that was used: ${`language-form__select-item--${country[1].isoCode.toLowerCase()}`
      // background-image is set by path for each country
      const countrySelect = `
        <span class="${config.classNames.selectItem} ${config.classNames.selectNotSelected}--${country[1].isoCode.toLowerCase()}"
              
              ${dataLableIso}="${country[1].isoCode}" 
              ${dataLableLang}="${country[1].languages}"
              ${country[1].forwardTarget != '' ? config.dataSets.forwardTarget + "=" + `${country[1].forwardTarget}` : ''}
            >
          ${country[0]}
        </span>
      `;


      // creating element and adding attributes from properties
      // const createListItem = document.createElement('span');
      // const item = createListItem;
      // item.innerHTML = country[0];
      // item.classList.add(config.classNames.selectItem);
      // item.setAttribute(config.dataSets.isoCode, `${country[1].isoCode}`);
      // item.setAttribute(config.dataSets.languages, `${country[1].languages}`);

      // if (country[1].forwardTarget != '') {
      //   item.setAttribute(config.dataSets.forwardTarget, `${country[1].forwardTarget}`);
      // }
      // Adding flags
      // item.classList.add(`language-form__select-item--${country[1].isoCode.toLowerCase()}`);  
      $(htmlItemsWrapper).append(DOMPurify.sanitize(countrySelect));
    });

    // Adds eventlistener to country select items 
    $(`.${config.classNames.selectItem}`).each((index, item) => {
      this._countryClickHandler(item);
    })
  }

  _addCurrentCountry() {
    const selectItems = document.querySelectorAll(`.${config.classNames.selectItem}`);
    const pageIsoCode = this._extractIsoAndLanguageFromUrl().isoCode;
    const selectedCountry = document.querySelector(config.selectors.selectSelected);
    $(selectItems).each((index, item) => {
      if (pageIsoCode.toUpperCase() === item.getAttribute(config.dataSets.isoCode)) {
        item.classList.add(config.classNames.countryActive);
        this.countrySelection.isoCode = item.getAttribute(config.dataSets.isoCode);
        const countryDetails = this._getDetailsByIsoCode(item.getAttribute(config.dataSets.isoCode));

        selectedCountry.innerHTML = DOMPurify.sanitize(this._findTheLanguageNeeded(countryDetails));
        selectedCountry.classList = '';
        selectedCountry.classList.add('language-form__select-selected');
        selectedCountry.classList.add(`language-form__select-selected--${countryDetails.isoCode.toLowerCase()}`);
       
        this._renderLanguageCheckboxes(countryDetails.languages);
      }
    })
  }

  _proofProdStage() {
      const splitted = window.location.pathname.split('/');
      const isProdStage = splitted[1] && splitted[2] && splitted[1].length === 2 && splitted[2].length === 2;
      return isProdStage
  }

  

  _selectLanguage(lang) {

  }

  _findTheLanguageNeeded(countryDetails) {
    const languageCodeFromUrl = this._extractIsoAndLanguageFromUrl();

    let title = '';

    switch(languageCodeFromUrl.languageSelected.toUpperCase()) {
      case 'DE':
        title = countryDetails.titleDE;
        break;
      case 'EN':
        title = countryDetails.titleEN;
        break;
      case 'ES':
        title = countryDetails.titleES;
        break;
      case 'FR':
        title = countryDetails.titleFR;
        break;
      case 'IT':
        title = countryDetails.titleIT;
        break;
      case 'JA':
        title = countryDetails.titleJA;
        break;
      case 'PT':
        title = countryDetails.titlePT;
        break;
      case 'RU':
        title = countryDetails.titleRU;
        break;
      case 'ZH':
        title = countryDetails.titleZH;
        break;
      default:
        title = countryDetails.titleEN;
    }

    return title;
  }

  _countryClickHandler(item) {
    $(item).on('click', (event) => {
      this.setLanguages = [];
      this._elements.$languageCheckbox.each((index, checkbox) => $(checkbox).show());

      const currentSelect = event.currentTarget;
      const targetDetails = this._getDetailsByIsoCode(currentSelect.getAttribute(config.dataSets.forwardTarget));
      const selectedCountry = document.querySelector(config.selectors.selectSelected);
      selectedCountry.innerHTML = currentSelect.innerHTML;
      
      // clearing classList to add new modifier to change flag
      selectedCountry.classList = '';
      selectedCountry.classList.add('language-form__select-selected');
      selectedCountry.classList.add(`language-form__select-selected--${currentSelect.getAttribute(config.dataSets.isoCode).toLowerCase()}`);
      this.countrySelection.isoCode = currentSelect.getAttribute(config.dataSets.isoCode).toLowerCase();
     
      if (currentSelect.hasAttribute(config.dataSets.forwardTarget)) {
        this._closeAllSelects(event, true);
        this._forwardPageToTarget(currentSelect);
        $('.language-form__language').removeClass(config.classNames.languagesHidden);
        this._renderLanguageCheckboxes(targetDetails.languages);
      } else {
        this._closeAllSelects(event, true);
        $('.language-form__language').removeClass(config.classNames.languagesHidden);
        this._renderLanguageCheckboxes(currentSelect.getAttribute(config.dataSets.languages));
      }
    })
  }

  _forwardPageToTarget(currentSelect) {
    this.countrySelection.isoCode = currentSelect.getAttribute('data-forward-target').toLowerCase();
    this._setCheckboxActiveAccordingToBrowserLanguage(currentSelect.getAttribute(config.dataSets.languages).split(';'));
    this.countrySelection.languageSelected = this.countrySelection.languageSelected;
  }

  _sortSelectOptionCountries(countries) {
    const countryArray = [];

    Object.values(countries).forEach((country, index) => {
      const countryTitle = this._findTheLanguageNeeded(country);
      const countryInformation = {
        sortTitle: decodeURI(countryTitle),
        isoCode: country.isoCode,
        languages: country.languages,
        forwardTarget: country.forwardTarget,
        showInSelector: country.showInSelector,
        countriesInDifferentLanguages: [
          country.titleDE, 
          country.titleEN, 
          country.titleES, 
          country.titleFR, 
          country.titleIT, 
          country.titleJA, 
          country.titlePT, 
          country.titleRU, 
          country.titleZH
        ]
      };

      countryArray.push([countryTitle, countryInformation]);
    })

    return countryArray.sort();
  }

  _setCheckboxActiveAccordingToBrowserLanguage(languages) {
    
    const pageLanguage = this._extractIsoAndLanguageFromUrl().languageSelected;
    const extractedIsoCode = this._extractIsoAndLanguageFromUrl().isoCode;
    const getCountryDetails = this._getDetailsByIsoCode(extractedIsoCode.toUpperCase());
    const getLanguage = this._findTheLanguageNeeded(getCountryDetails);

    const navigationActionButton = document.querySelector('.navigation__top-action--country');
    const checkboxesDisplayed = document.querySelectorAll(`.${config.classNames.languageCheckbox}`);
    let activeCheckboxes = 0;

    
    this._elements.$languageCheckbox.removeClass(config.classNames.languageCheckboxActive);

    languages.forEach((language, index) => {
        
        if (pageLanguage === language && activeCheckboxes === 0) {
          for (let i = 0; i < checkboxesDisplayed.length; i++) {
            if (checkboxesDisplayed[i].getAttribute(config.dataSets.checkboxLanguageCode) === language) {
              activeCheckboxes++;
              navigationActionButton.children[0].innerHTML = DOMPurify.sanitize(`${checkboxesDisplayed[i].children[1].innerHTML} | ${getLanguage}`);
              checkboxesDisplayed[i].classList.add(config.classNames.languageCheckboxActive);
              this.countrySelection.languageSelected = language;
            }
          }
        } else if (activeCheckboxes === 0) {
          let setLang = false;
          $(checkboxesDisplayed).each((index, checkbox) => {
            const getCheckboxAttribute = checkbox.getAttribute(config.dataSets.checkboxLanguageCode);

            if (checkbox.getAttribute(config.dataSets.checkboxLanguageCode) === pageLanguage){
              navigationActionButton.children[0].innerHTML = DOMPurify.sanitize(`${checkbox.innerText} | ${getLanguage}`);
            }
            if (!setLang && getCheckboxAttribute === pageLanguage && getCheckboxAttribute === language[0]) {
              setLang = true;
              this._setCheckboxActiveAndSetLanguage(checkbox);
            } else if (!setLang && getCheckboxAttribute !== pageLanguage && checkbox.getAttribute(config.dataSets.checkboxLanguageCode) === languages[0]) {
              activeCheckboxes++;
              setLang = true;
              this._setCheckboxActiveAndSetLanguage(checkbox);
            }
          })
        }
    })
  }

  _setCheckboxActiveAndSetLanguage(checkbox) {
    $(`.${config.classNames.languageCheckbox}`).removeClass(config.classNames.languageCheckboxActive);
    $(checkbox).addClass(config.classNames.languageCheckboxActive);
    this.countrySelection.languageSelected = checkbox.getAttribute(config.dataSets.checkboxLanguageCode);
  }

  _onCheckboxClicked() {
    var $this = this;
    const checkboxElements = document.querySelectorAll(`.${config.classNames.languageCheckbox}`);
    $(checkboxElements).each((index, element) => {
      element.addEventListener('click', (checkboxElement) => {
        checkboxElement.preventDefault();
        checkboxElement.stopPropagation();
        $(checkboxElements).removeClass(config.classNames.languageCheckboxActive)
        element.classList.add(config.classNames.languageCheckboxActive);
      
        // $this._elements.$checkbox.setAttribute('checked', 'checked')
        /*if the user clicks anywhere outside the select box,
        then close all select boxes:*/
  
        var selecteditems = $('.language-form__select-items')
        $this._elements.$customSelect.removeClass(config.classNames.customSelectActive)
        $this._elements.$country.removeClass(config.classNames.countryActive)
        selecteditems.addClass(config.classNames.selectItemsHide)
        
        // to get selected language informatioin
        $this.countrySelection.languageSelected = checkboxElement.currentTarget.dataset.languageCode;
      })
    })    
  }
   
  _closeAllSelects(e, choseLanguage) {
    if(e) {
      e.stopPropagation();
      e.stopPropagation();
    }

    var customSelect  = $('.language-form__custom-select');
    var countrySelectBox = $('.language-form__country');
    var selecteditems = $('.language-form__select-items');

    if (choseLanguage) {
        customSelect.removeClass(config.classNames.customSelectActive);
        countrySelectBox.removeClass(config.classNames.countryActive);
        selecteditems.addClass(config.classNames.selectItemsHide);
    }

    else if(!Breakpoints.isBreakpoint('xs') || !Breakpoints.isBreakpoint('sm')) {
      if(e && $(e.target).hasClass('overlay__inner') ){
        customSelect.removeClass(config.classNames.customSelectActive)
        countrySelectBox.removeClass(config.classNames.countryActive)
        selecteditems.addClass(config.classNames.selectItemsHide)
      } else if(!e) {
        customSelect.removeClass(config.classNames.customSelectActive);
        countrySelectBox.removeClass(config.classNames.countryActive);
        selecteditems.addClass(config.classNames.selectItemsHide);
      }
    }
   
    else if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
      $('.language-form__language').removeClass(config.classNames.languagesHidden)
    } 


    
      

     
  }
}

moduleRegistry.registerModule('LanguageForm', LanguageForm);
moduleRegistry.autoApplyModule('LanguageForm', config.selectors.root);
